// extracted by mini-css-extract-plugin
export default {"content":"LUQQOqKL","actions":"eoxSH2Pg","formControlLabel":"VLMlXbFQ","label":"W5ozBWTH","checkbox":"jq2qwHxM"};